export default __webpack_public_path__ + "static/media/upcomingEvents.7dae4505.jpg";